<template>
  <div class="card border-dark mb-3" style="max-width: 250px">
    <div class="row align-items-center text-center no-gutters mx-0">
      <div class="col-md-5 px-0">
        <img :src="lightColor" class="w-100" style="max-width: 85px" />
      </div>
      <div class="col-md-7 px-0">
        <div>{{ name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  props: {
    color: String,
    name: String,
  },
  setup(props) {
    const redLight = require("@/assets/light-red.png");
    const orangeLight = require("@/assets/light-orange.png");
    const yellowLight = require("@/assets/light-yellow.png");
    const greenLight = require("@/assets/light-green.png");
    const whiteLight = require("@/assets/light-white.png");
    const grayLight = require("@/assets/light-gray.png");

    const lightColor = ref("#");

    //function
    const changeColor = (color) => {
      switch (color) {
        case "red":
          lightColor.value = redLight;
          break;
        case "orange":
          lightColor.value = orangeLight;
          break;
        case "yellow":
          lightColor.value = yellowLight;
          break;
        case "green":
          lightColor.value = greenLight;
          break;
        case "white":
          lightColor.value = whiteLight;
          break;
        case "gray":
          lightColor.value = grayLight;
          break;

        default:
          lightColor.value = grayLight;
          break;
      }
    };

    changeColor(props.color);

    watch(
      () => props.color,
      (newValue) => {
        changeColor(newValue);
      }
    );
    return { lightColor };
  },
};
</script>

<style></style>
